import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-second',
  templateUrl: './second.component.html',
  styleUrls: ['./second.component.css']
})
export class SecondComponent implements OnInit {


  content = [
    {
      title: "Exclusive Content",
      icon: "groups",
      body: "Get access to content It Is Written Bible Study content that's only online!",
      color: "rgba(100, 0, 255, 0.2)"
    },
    {
      title: "Ask Questions",
      icon: "quiz",
      body: "Don't like to study alone?  Theres always somewhere available to answer your Bible Questions!",
      color: "rgba(0, 50, 255, 0.4)"
    },
    {
      title: "Exclusive Content",
      icon: "desktop_windows",
      body: "Get access to content It Is Written Bible Study content that's only online!",
      color: "rgba(100, 0, 55, 0.4)"
    },
    {
      title: "Ask Questions",
      icon: "laptop_chromebook",
      body: "Don't like to study alone?  Theres always somewhere available to answer your Bible Questions!",
      color: "rgba(255, 0, 0, 0.4)"
    },
  ]
  constructor() { }

  ngOnInit(): void {
  }

}
